export const AMEXPLATINUM = [
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#UBER_CASH",
    itemType: "CONFIG",
    benefitId: "UBER_CASH",
    label: "Uber Cash Credit",
    description: "$15 Uber Cash monthly + $20 in December",
    amount: 15,
    intervalMonths: 1,
    periodType: "CALENDAR_MONTH",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#DIGITAL_ENTERTAINMENT",
    itemType: "CONFIG",
    benefitId: "DIGITAL_ENTERTAINMENT",
    label: "Digital Entertainment Credit",
    description: "$20 per month for select services like Disney+, Hulu, Peacock, etc.",
    amount: 20,
    intervalMonths: 1,
    periodType: "CALENDAR_MONTH",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#SAKS_CREDIT",
    itemType: "CONFIG",
    benefitId: "SAKS_CREDIT",
    label: "Saks Fifth Avenue Credit",
    description: "$50 from Jan–Jun and $50 from Jul–Dec",
    amount: 50,
    intervalMonths: 6,
    periodType: "HALF_YEAR",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#AIRLINE_FEE_CREDIT",
    itemType: "CONFIG",
    benefitId: "AIRLINE_FEE_CREDIT",
    label: "Airline Incidental Fee Credit",
    description: "$200 per calendar year for incidental airline fees on a selected airline",
    amount: 200,
    intervalMonths: 12,
    periodType: "CALENDAR_YEAR",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#CLEAR_CREDIT",
    itemType: "CONFIG",
    benefitId: "CLEAR_CREDIT",
    label: "CLEAR® Plus Credit",
    description: "Up to $189 per year for CLEAR® membership",
    amount: 189,
    intervalMonths: 12,
    periodType: "CALENDAR_YEAR",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#GLOBAL_ENTRY_TSA",
    itemType: "CONFIG",
    benefitId: "GLOBAL_ENTRY_TSA",
    label: "Global Entry or TSA PreCheck Fee Credit",
    description: "Get up to $100 every 4 years for Global Entry or every 4.5 years for TSA PreCheck",
    amount: 100,
    intervalMonths: 48,
    periodType: "ROLLING",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#WALGREENS_EQUINOX",
    itemType: "CONFIG",
    benefitId: "EQUINOX_CREDIT",
    label: "Equinox Credit",
    description: "$25 monthly toward Equinox+ or Equinox memberships",
    amount: 25,
    intervalMonths: 1,
    periodType: "CALENDAR_MONTH",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#LOUNGE_ACCESS",
    itemType: "CONFIG",
    benefitId: "LOUNGE_ACCESS",
    label: "Lounge Access",
    description: "Access to Centurion Lounge, Priority Pass, Delta Sky Club, and more",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#FINE_HOTELS",
    itemType: "CONFIG",
    benefitId: "FINE_HOTELS",
    label: "Fine Hotels & Resorts Benefits",
    description: "Room upgrades, daily breakfast, and more when booking through Amex Travel",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#HILTON_GOLD_STATUS",
    itemType: "CONFIG",
    benefitId: "HILTON_GOLD_STATUS",
    label: "Hilton Honors Gold Status",
    description: "Automatic elite status just by having the card",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXPLATINUM",
    SK: "CONFIG#MARRIOTT_GOLD_STATUS",
    itemType: "CONFIG",
    benefitId: "MARRIOTT_GOLD_STATUS",
    label: "Marriott Bonvoy Gold Elite Status",
    description: "Automatic elite status just by having the card",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
];

export const AMEXGOLD = [
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#DINING_CREDIT",
    itemType: "CONFIG",
    benefitId: "DINING_CREDIT",
    label: "Dining Credit",
    description:
      "Up to $10 in monthly statement credits at Grubhub, The Cheesecake Factory, Goldbelly, Wine.com, and select restaurants. Enrollment required.",
    amount: 10,
    intervalMonths: 1,
    periodType: "CALENDAR_MONTH",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#UBER_CASH",
    itemType: "CONFIG",
    benefitId: "UBER_CASH",
    label: "Uber Cash Credit",
    description:
      "Up to $10 in monthly Uber Cash for U.S. Uber Eats orders and rides. Add the Gold Card to your Uber account to receive the benefit.",
    amount: 10,
    intervalMonths: 1,
    periodType: "CALENDAR_MONTH",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#REWARDS_RESTAURANTS",
    itemType: "CONFIG",
    benefitId: "REWARDS_RESTAURANTS",
    label: "4X Points at Restaurants",
    description: "Earn 4X Membership Rewards® points at restaurants, including takeout and delivery.",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#REWARDS_SUPERMARKETS",
    itemType: "CONFIG",
    benefitId: "REWARDS_SUPERMARKETS",
    label: "4X Points at U.S. Supermarkets",
    description: "Earn 4X Membership Rewards® points at U.S. supermarkets on up to $25,000 per year in purchases, then 1X.",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#REWARDS_FLIGHTS",
    itemType: "CONFIG",
    benefitId: "REWARDS_FLIGHTS",
    label: "3X Points on Flights",
    description: "Earn 3X Membership Rewards® points on flights booked directly with airlines or on amextravel.com.",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#HOTEL_COLLECTION",
    itemType: "CONFIG",
    benefitId: "HOTEL_COLLECTION",
    label: "The Hotel Collection Credit",
    description:
      "$100 hotel credit for qualifying charges when booking a stay of at least two consecutive nights through The Hotel Collection. Terms apply.",
    amount: 100,
    intervalMonths: 12,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#DunkinCredit",
    itemType: "CONFIG",
    benefitId: "DunkinCredit",
    label: "$84 Dunkin' Credit",
    description:
      "With the $84 Dunkin' Credit, you can earn up to $7 in monthly statement credits after you enroll and pay with the American Express® Gold Card at U.S. Dunkin' locations.",
    amount: 7,
    intervalMonths: 1,
    periodType: "CALENDAR_MONTH",
    autoRenew: true,
    benefitType: "RECURRING",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#PURCHASE_PROTECTION",
    itemType: "CONFIG",
    benefitId: "PURCHASE_PROTECTION",
    label: "Purchase Protection",
    description:
      "Covers eligible purchases against accidental damage or theft for up to 90 days from the purchase date. Up to $10,000 per occurrence, $50,000 per calendar year.",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#EXTENDED_WARRANTY",
    itemType: "CONFIG",
    benefitId: "EXTENDED_WARRANTY",
    label: "Extended Warranty",
    description:
      "Extends the original manufacturer's warranty for up to one additional year on eligible purchases. Coverage up to $10,000 per item, $50,000 per calendar year.",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#NO_FOREIGN_FEES",
    itemType: "CONFIG",
    benefitId: "NO_FOREIGN_FEES",
    label: "No Foreign Transaction Fees",
    description: "Make purchases abroad without incurring foreign transaction fees.",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#MEMBERSHIP_REWARDS",
    itemType: "CONFIG",
    benefitId: "MEMBERSHIP_REWARDS",
    label: "Membership Rewards® Program",
    description: "Earn points on purchases and redeem them for travel, gift cards, statement credits, and more.",
    amount: null,
    intervalMonths: null,
    periodType: null,
    autoRenew: false,
    benefitType: "STATIC",
  },
  {
    PK: "CARD#AMEXGOLD",
    SK: "CONFIG#RESY_CREDIT",
    itemType: "CONFIG",
    benefitId: "RESY_CREDIT",
    label: "$100 Resy Credit",
    description:
      "Get up to $100 in statement credits each calendar year after you pay with the American Express® Gold Card to dine at U.S. Resy restaurants or make other eligible Resy purchases. That's up to $50 in statement credits from January through June and up to $50 in statement credits from July through December. Enrollment required.‡",
    amount: 50,
    intervalMonths: 6,
    periodType: "HALF_YEAR",
    autoRenew: true,
    benefitType: "RECURRING",
  },
];

export function getCreditCardBenefitsConfig(cardId) {
  if (cardId === "AMEXPLATINUM") {
    return AMEXPLATINUM;
  }
  if (cardId === "AMEXGOLD") {
    return AMEXGOLD;
  }
  return [];
}
